import { useDeleteGantnerDevice } from 'api/GantnerDevices'
import { useCurrentSiteId } from 'contexts/SiteConfig'
import { useTranslation } from 'react-i18next'
import {
  ApiErrorNotification,
  Notification,
  useNotificationContext,
} from 'ui/components/Notification'
import { Text } from 'ui/components/Text'
import { ConfirmationModal } from 'ui/Modal'

export const DeletePrompt = ({ deleting, onClose }) => {
  const { t } = useTranslation()
  const notifications = useNotificationContext()
  const siteId = useCurrentSiteId()

  const { isLoading: isDeleting, mutate } = useDeleteGantnerDevice()

  const handleConfirm = () => {
    mutate([siteId, deleting.id], {
      onSuccess: () => {
        notifications.notify(
          <Notification
            title={t(
              'settings.integrations.gantner.devices.device.delete_confirmation.notification.title'
            )}
            description={t(
              'settings.integrations.gantner.devices.device.delete_confirmation.notification.description'
            )}
            variant="success"
            autoDismiss
          />
        )

        onClose()
      },
      onError: (e: any) => {
        notifications.notify(<ApiErrorNotification error={e} />)
      },
    })
  }

  return (
    <ConfirmationModal
      isOpen={deleting !== undefined}
      onClose={onClose}
      title={t('settings.integrations.gantner.devices.device.delete_confirmation.title')}
      confirmButtonLabel={t('modal_button.delete')}
      confirming={isDeleting}
      variant="danger"
      onConfirm={handleConfirm}
    >
      <Text type="caption">
        {t('settings.integrations.gantner.devices.device.delete_confirmation.description', {
          deviceName: deleting?.name,
        })}
      </Text>
    </ConfirmationModal>
  )
}
